import React from "react"
import classnames from "classnames"
import {
  H3,
  Content,
  AlertIcon,
  ButtonIcon,
  CrossIcon
} from "AtomicComponents"
import { WINDOW } from "AtomicUtils/environment"
import styles from "./BrowserWarning.less"
import oldBrowserDetector from 'AtomicUtils/oldBrowserDetector'

class BrowserWarning extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      showBrowserWarning: false
    }
  }

  componentDidMount(){
    if (WINDOW){
      if (oldBrowserDetector() && !WINDOW.sessionStorage.getItem("BrowserWarning")) {
        this.setState({
          showBrowserWarning: true,
        })
      }
    }
  }

  _handleClose = () => {
    this.setState({
      showBrowserWarning: false
    }, () => {
      WINDOW.sessionStorage.setItem('BrowserWarning','visible')
    })
  }

  render() {
    const { showBrowserWarning } = this.state
    const { warningMessage } = this.props

    if (!showBrowserWarning) return null

    return (
      <div className={classnames({
        [styles.BrowserWarning]: true
      })}>
        <div
           className={classnames({
            [styles.closeButton]: true
          })}
        >
          <ButtonIcon
            onClick={this._handleClose}
          >
            <CrossIcon style={{
              width: "15px",
              height: "15px"
            }} />
          </ButtonIcon>
        </div>
        <div className={classnames({
          [styles.TitleSection]: true
        })}>
          <div className={classnames({
            [styles.Icon]: true
          })}>
            <AlertIcon />
          </div>
          <div className={classnames({
            [styles.Title]: true
          })}>
            <H3 withDetails>
              Please update your web browser
            </H3>
          </div>
        </div>
        <div className={classnames({
            [styles.ContentSection]: true
          })}>
          <Content
            textAlign={'center'}
            xmlString={warningMessage}
          />
        </div>
    </div>
    )
  }
}


export default BrowserWarning



// WEBPACK FOOTER //
// ./src/AtomicContainers/BrowserWarning/BrowserWarning.jsx